// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"bs_dF","poster":"bs_dG","posterTitle":"bs_dH","posterQuarter":"bs_gl","posterLabel":"bs_gm","sidebarButtonWrapper":"bs_dJ","sidebarButton":"bs_dK"};